import React from "react"
import withStyles from '@material-ui/core/styles/withStyles'
import UrlHelper from "../Helpers/urlHelper";

const styles = theme => ({
  topBar: {
    maxWidth: '119px',
    listStyleType: 'none',
    display: 'block',
    position: 'absolute',
    zIndex: '99999',
    boxShadow: 'rgba(0, 0, 0, 0.5) 0px -3px 1.5em',
    backgroundColor: 'rgb(255, 255, 255)',
    margin: '71px 0px 0px 6px',
    padding: '6px',
    borderRadius: '0.2em',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '0.85em',
    color: 'rgb(113, 113, 113)',
    '& ::after': {
      content: '""',
      display: 'block',
      width: '0px',
      height: '0px',
      position: 'absolute',
      top: '-10px',
      left: '10px',
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderBottom: '10px solid rgb(255, 255, 255)',
    },
    '& li:first-child': {
      borderBottom: '1px solid rgb(204, 204, 204)',
      marginTop: '3px',
    },
    '& li': {
      display: 'list-item',
      '& .styledButton': {
        width: '100%',
        fontSize: '1em',
        margin: '0 !important',
        padding: '10px 14px !important',
        borderWidth: 'initial',
        borderStyle: 'none',
        borderColor: 'initial',
        borderImage: 'initial',
        boxSizing: 'border-box',
        outlineStyle: 'none',
        textAlign: 'center',
        fontWeight: 'bold',
        backgroundColor: 'white',
        display: 'block',
        cursor: 'pointer',
        color: 'rgb(113, 113, 113)',
        borderRadius: '0.2em',
      }
    }
  }
});

class UserPainelWidget extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      show: this.props.show,
      isLogged: null
    };

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ show: false });
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }


  componentDidMount() {
    this.props.onRef(this)
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
    document.removeEventListener('mousedown', this.handleClickOutside);

  }

  handleUserMenuChange = () => {
    this.setState({ show: this.state.show !== true });
  }

  handleMouseLeave = () => {
    setTimeout(() => {
      this.setState(state => ({ show: !state.show }));
    }, 100000000);
  }

  handleMinhaContaClick = () => {
    window.location.href = this.buildProfileUrl(window.location.pathname);
  }

  handleSairClick = () => {
    window.location.href = this.buildLogoutUrl();
  }

  buildLoginUrl() {
    return UrlHelper.buildLoginUrl();
  }

  buildLogoutUrl() {
    return UrlHelper.buildLogoutUrl();
  }

  buildProfileUrl() {
    return UrlHelper.buildProfileUrl();
  }

  onBlur(event) {
    if (!event.currentTarget.contains(event.relatedTarget)) {
        this.handleMouseLeave()
    }
}


  render() {
    const { classes } = this.props;

    if (this.state.show && this.props.isLogged !== null)
      return (
        <ul ref={this.setWrapperRef} tabIndex="0" className={classes.topBar} onBlur={this.handleMouseLeave}>
          <li>
            <button className="styledButton" onClick={this.handleMinhaContaClick}>Minha conta</button>
          </li>
          <li>
            <button className="styledButton" onClick={this.handleSairClick}>Sair</button>
          </li>
        </ul>
      );
    return null;
  }

}

export default withStyles(styles)(UserPainelWidget);
